import type { MarkerNoteOfSnapshot } from "./types";

export const markerNoteOfSnapshot: MarkerNoteOfSnapshot = ({ snapshot }) => ({
  content: snapshot.content,
  createdBy: snapshot.createdByName,
  createdAt: snapshot.createdAt,
  updatedAt: snapshot.updatedAt,
});
